import { showAlert } from '@/components/Modal/utils'
import axios, {
	type AxiosError,
	type AxiosInstance,
	type AxiosRequestConfig,
	type AxiosResponse,
} from 'axios'
import { merge } from 'lodash-es'
import { toast } from 'react-hot-toast'
import storage from '../Storage'
import { refreshTokens } from '../fetchers/auth'
import { navigateToLoginPage } from '../navigate'
import { hideLoadingToast, showLoadingToast } from '../ui'

export default function withInterceptors(axiosInstance: AxiosInstance) {
	axiosInstance.interceptors.request.use(async (config) => {
		try {
			config.headers.set('x-jike-access-token', storage.auth.token)

			if (config.withLoadingToast) {
				showLoadingToast()
			}

			// inject path params
			if (config.url?.includes(':')) {
				for (const [key, value] of Object.entries(config.params)) {
					if (config.url.includes(`:${key}`)) {
						config.url = config.url.replace(`:${key}`, value as string)
						delete config.params[key]
					}
				}
			}

			return config
		} catch (e) {
			console.error('in request interceptor catch', e)
		}

		return config
	})

	axiosInstance.interceptors.response.use(
		(res: AxiosResponse) => {
			if (res.config.withLoadingToast) {
				hideLoadingToast()
			}
			const toastText = res.data.toast ?? res.data.toastMessage
			if (!res.config.suppressToast && toastText) {
				toast.success(toastText)
			}
			return res
		},
		async (error: AxiosError<any>) => {
			switch (true) {
				case error.response?.data?.code === 'E101' || error.response?.status === 401:
					return refreshTokens()
						.then((tokens) =>
							axios
								.request(
									merge({}, error.config as AxiosRequestConfig, {
										headers: {
											'x-jike-access-token': tokens.token,
										},
									})
								)
								.catch(() => null)
						)
						.catch(() => {
							navigateToLoginPage()
							throw error
						})

				case error.response?.data?.code === 'E202':
					if (error.response?.data?.alert) {
						const { title, description, confirmButton } = error.response.data.alert
						showAlert(title, description, {
							labels: {
								cancel: undefined,
								confirm: confirmButton.text,
							},
						}).then(() => {
							if (confirmButton.linkUrl) {
								window.location.href = confirmButton.linkUrl
							}
						})
					}
					break
				case error.response?.status === 429:
					toast.error('操作过于频繁')
					break
				case !error.response?.config.suppressToast && !!error.response?.data?.error:
					{
						if (!['该帐号已注销', '该用户主页无法访问'].includes(error.response.data.error)) {
							toast.error(error.response.data.error)
						}
					}
					break
			}

			if (error.config?.withLoadingToast) {
				hideLoadingToast()
			}

			return Promise.reject(error)
		}
	)
}
